import { createAsyncThunk } from '@reduxjs/toolkit'
import { Body, authPost, authGet } from '../../../api'
import { urlTTS, urlConsole } from '../../../config'
import { addNotify } from '../notify/notifySlice'
import { extractErrorMessage, resolveTtsErrorMessage } from '../../../functions'

interface ISendPayload {
  pitch: number
  rate: number
  text: string
  voice: string
  volume: number
}
export const ttsSend = createAsyncThunk('tts/ttsSend', async (data: ISendPayload & { id: string }, { dispatch }) => {
  const sentDate = Date.now()
  try {
    const res = await authPost(urlTTS + '/synthesize', { ...data } as Body)

    if (!res || res.status >= 400) {
      throw new Error('Ошибка на уровне HTTP-запроса')
    }

    if (res.data?.response_code === 2) {
      return res.data
    }

    if (res.data?.response_code === 1) {
      const error = extractErrorMessage(res.data)
      const message = resolveTtsErrorMessage(error)
      return dispatch(addNotify({ text: message }))
    }

    if (res.data?.response_code === 3) {
      return dispatch(addNotify({ text: res.data?.msg }))
    }

    const generationTime = Date.now() - sentDate
    const message = res.data?.response?.[0] ?? {}

    return {
      ...message,
      generationTime,
      id: data.id,
      pitch: data.pitch,
      rate: data.rate,
      volume: data.volume,
    }
  } catch (error) {
    console.error('Ошибка в запросе:', error)

    if (error instanceof Error) {
      return dispatch(addNotify({ text: error.message }))
    }

    return dispatch(addNotify({ text: 'Неизвестная ошибка' }))
  }
})

export const getVoices = createAsyncThunk('tts/getVoices', async () => {
  const res = await authGet(urlConsole + '/get_voices')
  return res.data?.voices ?? []
})

export const getTtsConfig = createAsyncThunk('tts/getTtsConfig', async () => {
  const res = await authGet(urlTTS + '/get_config')
  return res.data?.response ?? []
})
